// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg viewBox=%270 0 256 256%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cfilter id=%27n%27%3E%3CfeTurbulence type=%27fractalNoise%27 baseFrequency=%270.9%27 numOctaves=%274%27 stitchTiles=%27stitch%27/%3E%3C/filter%3E%3Crect width=%27100%25%27 height=%27100%25%27 filter=%27url%28%23n%29%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Bioluminescent Forest Theme — Global Styles */

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #0a0f0a;
  color: #c8e6c9;
}

/* Organic gradient mesh background */
body::before {
  content: '';
  position: fixed;
  inset: 0;
  z-index: -2;
  background:
    radial-gradient(ellipse 80% 60% at 10% 90%, rgba(0, 60, 30, 0.4) 0%, transparent 60%),
    radial-gradient(ellipse 60% 80% at 85% 20%, rgba(0, 40, 50, 0.3) 0%, transparent 55%),
    radial-gradient(ellipse 50% 50% at 50% 50%, rgba(0, 30, 20, 0.2) 0%, transparent 70%),
    radial-gradient(ellipse 40% 40% at 30% 30%, rgba(0, 80, 40, 0.15) 0%, transparent 50%);
  pointer-events: none;
}

/* Subtle noise texture overlay */
body::after {
  content: '';
  position: fixed;
  inset: 0;
  z-index: -1;
  opacity: 0.03;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 256px 256px;
  pointer-events: none;
}

code {
  font-family: 'JetBrains Mono', source-code-pro, Menlo, Monaco, Consolas, monospace;
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #0a0f0a;
}

::-webkit-scrollbar-thumb {
  background: #1a3a2a;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #2a5a3a;
}

/* Blink animation for preset save mode */
@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
}

/* Pulse glow animation */
@keyframes pulseGlow {
  0%, 100% { box-shadow: 0 0 8px rgba(0, 255, 200, 0.15), inset 0 0 8px rgba(0, 255, 200, 0.03); }
  50% { box-shadow: 0 0 16px rgba(0, 255, 200, 0.3), inset 0 0 12px rgba(0, 255, 200, 0.05); }
}

/* Pulsing dots for empty states */
@keyframes pulseDot {
  0%, 80%, 100% { opacity: 0.2; transform: scale(0.8); }
  40% { opacity: 1; transform: scale(1.2); }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,gDAAgD;;AAEhD;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,+EAA+E;EAC/E,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;EACzB,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,WAAW;EACX;;;;0FAIwF;EACxF,oBAAoB;AACtB;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,yDAAoT;EACpT,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,kFAAkF;AACpF;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA,yBAAyB;AACzB;EACE,WAAW,kFAAkF,EAAE;EAC/F,MAAM,mFAAmF,EAAE;AAC7F;;AAEA,kCAAkC;AAClC;EACE,gBAAgB,YAAY,EAAE,qBAAqB,EAAE;EACrD,MAAM,UAAU,EAAE,qBAAqB,EAAE;AAC3C","sourcesContent":["/* Bioluminescent Forest Theme — Global Styles */\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #0a0f0a;\n  color: #c8e6c9;\n}\n\n/* Organic gradient mesh background */\nbody::before {\n  content: '';\n  position: fixed;\n  inset: 0;\n  z-index: -2;\n  background:\n    radial-gradient(ellipse 80% 60% at 10% 90%, rgba(0, 60, 30, 0.4) 0%, transparent 60%),\n    radial-gradient(ellipse 60% 80% at 85% 20%, rgba(0, 40, 50, 0.3) 0%, transparent 55%),\n    radial-gradient(ellipse 50% 50% at 50% 50%, rgba(0, 30, 20, 0.2) 0%, transparent 70%),\n    radial-gradient(ellipse 40% 40% at 30% 30%, rgba(0, 80, 40, 0.15) 0%, transparent 50%);\n  pointer-events: none;\n}\n\n/* Subtle noise texture overlay */\nbody::after {\n  content: '';\n  position: fixed;\n  inset: 0;\n  z-index: -1;\n  opacity: 0.03;\n  background-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\");\n  background-size: 256px 256px;\n  pointer-events: none;\n}\n\ncode {\n  font-family: 'JetBrains Mono', source-code-pro, Menlo, Monaco, Consolas, monospace;\n}\n\n/* Custom scrollbar */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #0a0f0a;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #1a3a2a;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #2a5a3a;\n}\n\n/* Blink animation for preset save mode */\n@keyframes blink {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.3; }\n}\n\n/* Pulse glow animation */\n@keyframes pulseGlow {\n  0%, 100% { box-shadow: 0 0 8px rgba(0, 255, 200, 0.15), inset 0 0 8px rgba(0, 255, 200, 0.03); }\n  50% { box-shadow: 0 0 16px rgba(0, 255, 200, 0.3), inset 0 0 12px rgba(0, 255, 200, 0.05); }\n}\n\n/* Pulsing dots for empty states */\n@keyframes pulseDot {\n  0%, 80%, 100% { opacity: 0.2; transform: scale(0.8); }\n  40% { opacity: 1; transform: scale(1.2); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
